/**
 * @generated SignedSource<<ca3487018588f938fcab4c6a21e4765b>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SignalDetailProducts_StoreProducts$data = ReadonlyArray<{
  readonly id: string;
  readonly " $fragmentSpreads": FragmentRefs<"LinkedStoreProductItem_StoreProduct">;
  readonly " $fragmentType": "SignalDetailProducts_StoreProducts";
}>;
export type SignalDetailProducts_StoreProducts$key = ReadonlyArray<{
  readonly " $data"?: SignalDetailProducts_StoreProducts$data;
  readonly " $fragmentSpreads": FragmentRefs<"SignalDetailProducts_StoreProducts">;
}>;

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "SignalDetailProducts_StoreProducts",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "LinkedStoreProductItem_StoreProduct"
    }
  ],
  "type": "StoreProduct",
  "abstractKey": null
};

(node as any).hash = "01459cb678397a26c01f5049d57ae956";

export default node;
